export default "__VITE_ASSET__PpqCvjYA__"